import * as errorConstants from './errorConstants';

/**
 * Default error message.
 */
const DEFAULT_MESSAGE = 'Sorry, an error occurred. Please, try again.';

/**
 * It defines all the application error messages.
 */
const appErrorMessages = {
  upload: {
    [errorConstants.MULTIPLE_FILES_NOT_ALLOWED]: 'Multiple files upload is not allowed.',
    [errorConstants.FOLDER_NOT_ALLOWED]: 'Folder upload is not allowed.',
    [errorConstants.INCORRECT_FILE_SIZE]: 'Your file was too large. Files must be under 5mb.',
    [errorConstants.INCORRECT_FILE_TYPE]: `Sorry, we can't identify fonts in that kind of file. 
      Please upload a png or jpg instead`,
    [errorConstants.DEFAULT]: DEFAULT_MESSAGE,
  },
  crop: {
    [errorConstants.NO_DATA_FOUND_FOR_IMAGE_ERROR]: `No text found. If there is text in this image, use the manual crop
      tool to select it.`,
    [errorConstants.CANCELED_AUTO_RECOGNITION_ERROR]: `No text found. If there is text in this image, use the manual
      crop tool to select it.`,
    [errorConstants.DEFAULT]: DEFAULT_MESSAGE,
  },
  result: {
    [errorConstants.REQUEST_RESULTS_ERROR]: `Something went wrong. Please try again later, or click here to go back and
      try again.`,
    [errorConstants.BAD_RESULTS_ERROR]: `Bad results? Be sure to rotate your image so the text is horizontal. Make sure
      the crop box is only around one line of text. Click here to go back.`,
    [errorConstants.DEFAULT]: DEFAULT_MESSAGE,
  },
};

export default appErrorMessages;



// WEBPACK FOOTER //
// ./src/constants/appErrors.js